var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78133 2.11434C2 2.89501 2 4.15234 2 6.66634V9.33301C2 11.847 2 13.1043 2.78133 13.885C3.56267 14.6657 4.81933 14.6663 7.33333 14.6663H8.66667C11.1807 14.6663 12.438 14.6663 13.2187 13.885C13.9993 13.1037 14 11.847 14 9.33301V6.66634C14 4.15234 14 2.89501 13.2187 2.11434C12.4373 1.33367 11.1807 1.33301 8.66667 1.33301H7.33333C4.81933 1.33301 3.562 1.33301 2.78133 2.11434ZM5.33333 6.16634C5.20073 6.16634 5.07355 6.21902 4.97978 6.31279C4.88601 6.40656 4.83333 6.53373 4.83333 6.66634C4.83333 6.79895 4.88601 6.92613 4.97978 7.01989C5.07355 7.11366 5.20073 7.16634 5.33333 7.16634H10.6667C10.7993 7.16634 10.9265 7.11366 11.0202 7.01989C11.114 6.92613 11.1667 6.79895 11.1667 6.66634C11.1667 6.53373 11.114 6.40656 11.0202 6.31279C10.9265 6.21902 10.7993 6.16634 10.6667 6.16634H5.33333ZM5.33333 8.83301C5.20073 8.83301 5.07355 8.88569 4.97978 8.97945C4.88601 9.07322 4.83333 9.2004 4.83333 9.33301C4.83333 9.46562 4.88601 9.59279 4.97978 9.68656C5.07355 9.78033 5.20073 9.83301 5.33333 9.83301H8.66667C8.79927 9.83301 8.92645 9.78033 9.02022 9.68656C9.11399 9.59279 9.16667 9.46562 9.16667 9.33301C9.16667 9.2004 9.11399 9.07322 9.02022 8.97945C8.92645 8.88569 8.79927 8.83301 8.66667 8.83301H5.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0912a349daed1bd829cf02edf7e1f4d3.svg";
export { ForwardRef as ReactComponent };